import { YearInput } from '@apply/ui';
import { stateSelectorValues } from '@apply/ui/src/lib/question/question-shared';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { FileUploader } from 'devextreme-react';
import { alertModal } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
import React, { useState, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { BusinessAndPeopleApi } from '@apply/api';

interface IEditBorrowerOwnerEntityModal {
    isOpen: boolean;
    onCloseCallback?: () => void;
    applicationInsights: ApplicationInsights;
    borrowerEntityId: any;
    selectedBusinessId: any;
    entityOwnerId: any;
}
export const EditBorrowerOwnerEntityModal: React.FC<IEditBorrowerOwnerEntityModal> = (props) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(props.applicationInsights);

    const { authentication, isFeatureEnabled } = useAuthentication();
    const [validation, set_validation] = useState(undefined);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [saveEnabled, set_saveEnabled] = useState(false);

    const [ownerEntity, set_ownerEntity] = useState(null);
    const [canContinue, set_canContinue] = useState(true);

    const [businessId, set_businessId] = useState(0);
    const [entityId, set_entityId] = useState(null);
    const [yearIncorporated, set_yearIncorporated] = useState<string | null>(null);
    const [stateIncorporated, set_stateIncorporated] = useState('');
    const [percentageOwnership, set_percentageOwnership] = useState(0);
    const [entityName, set_entityName] = useState('');
    const [tin, set_tin] = useState('');

    const onYearSelection = (value: any) => {
        if (value && value !== '' && value != null) {
            const selectedDate = new Date(value).toISOString().split('T')[0];
            if (selectedDate) {
                set_yearIncorporated(selectedDate);
            }
        } else {
            set_yearIncorporated(null);
        }
    };

    useEffect(() => {
        set_businessId(props.selectedBusinessId);
    }, [props.selectedBusinessId]);

    useEffect(() => {
        set_entityId(props.borrowerEntityId);
    }, [props.borrowerEntityId]);

    const loadDetails = async (id: number) => {
        // set_loadingMessage("Loading...");
        // set_loadingOpen(true);
        // const response = await businessAndPeopleApi.getOwnerEntityById(id);
        // if (!response || response.statusCode !== 200) {
        //   return;
        // }
        // set_ownerEntity(response.result);
    };

    useEffect(() => {
        async function ownerEntityIdChanged() {
            resetState();
            if (!props.entityOwnerId || props.entityOwnerId <= 0) {
                set_ownerEntity(null);
                return;
            }

            await loadDetails(props.entityOwnerId);
            set_loadingOpen(false);
        }

        ownerEntityIdChanged();
    }, [props.entityOwnerId]);

    useEffect(() => {
        setState(ownerEntity);
    }, [ownerEntity]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid =
            percentageOwnership > 0 &&
            yearIncorporated !== null &&
            stateIncorporated != '' &&
            tin.length > 0 &&
            entityName !== '';

        set_canContinue(fieldsValid);
    }, [percentageOwnership, yearIncorporated, tin, entityName]);

    const setState = (ownerEntity: any) => {
        if (!ownerEntity) {
            return;
        }
        set_percentageOwnership(ownerEntity.percentageOwnership);
        set_stateIncorporated(ownerEntity.stateIncorporated);
        set_yearIncorporated(ownerEntity.yearIncorporated);
        set_tin(ownerEntity.tin);
        set_entityName(ownerEntity.entityName);
    };

    const resetState = () => {
        set_businessId(0);
        set_entityId(null);
        set_percentageOwnership(0);
        set_stateIncorporated('');
        set_yearIncorporated(null);
        set_tin('');
        set_entityName('');
    };

    const getSuccessMessage = (id: number) => {
        if (id === 0) {
            return 'Your Borrower Entity Owner - Entity was added successfully.';
        } else {
            return 'Your Borrower Entity Owner - Entity was updated successfully';
        }
    };

    const getGeneralErrorMessage = () => {
        return 'An error has occurred while communicating with our server.  Please try your operation again.';
    };

    const handleClose = () => {
        set_ownerEntity(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const cancelBorrowerEntityOwnerEntity = () => {
        set_ownerEntity(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const validateOwnerEntity = async () => {
        ////Check should validate whether an owner entity already exists on a borrower entity or not or if a borrower entity already exists in the system
        // set_loadingMessage("Validating...");
        // set_loadingOpen(true);
        // set_validation(undefined);
        // try {
        //   const model = {
        //     entityId,
        //     id: ownerEntityId
        //   };
        //   const response = await businessAndPeopleApi.validateOwnerEntity(model);
        //   if (response.statusCode !== 200 || !response.result) {
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   if (response.result.hasErrors || response.result.hasWarnings) {
        //     set_validation(response.result);
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   return true;
        // } catch (ex) {
        //   set_loadingOpen(false);
        //   set_validation(undefined);
        //   alertModal({
        //     message:
        //       getGeneralErrorMessage(),
        //   });
        //   return false;
        // }
    };

    const saveOwnerEntity = async () => {
        // try {
        //     const isValid = await validateOwnerEntity();
        //     if (!isValid) {
        //         return;
        //     }
        //     const model = {
        //         entityId: props.borrowerEntityId,
        //         ownerEntityId: props.entityOwnerId ?? 0,
        //         percentageOwnership,
        //         entityName,
        //         yearIncorporated: yearIncorporated ? new Date(yearIncorporated).toISOString().split('T')[0] : null,
        //         stateIncorporated,
        //         tin,
        //     };
        //     const response = await businessAndPeopleApi.saveBorrowerEntityOwnerEntity(model);
        //     if (response.statusCode !== 200 || !response.result) {
        //         set_loadingOpen(false);
        //         alert(response.errors[0]);
        //         return false;
        //     }
        //     set_loadingOpen(false);
        //     alertModal({
        //         title: 'Success',
        //         message: getSuccessMessage(model.ownerEntityId),
        //         onConfirm: () => {
        //             handleClose();
        //         },
        //     });
        // } catch (ex) {
        //     set_loadingOpen(false);
        //     set_validation(undefined);
        //     alertModal({
        //         message: getGeneralErrorMessage(),
        //     });
        //     return false;
        // }
    };

    return (
        <div>
            <Dialog
                open={props.isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '500px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>
                                        {!props.entityOwnerId && props.entityOwnerId === 0
                                            ? 'Add Owner (Entity)'
                                            : 'Edit Owner (Entity)'}
                                    </h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content'>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={{
                                                padding: 0,
                                            }}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='ownership-percentage'>Percentage Ownership</label>
                                                        <span className='helper'>
                                                            <span className='text'>Percent of company owned by this entity</span>
                                                        </span>
                                                        <NumericFormat
                                                            id='ownership-percentage'
                                                            decimalScale={2}
                                                            allowNegative={false}
                                                            suffix={'%'}
                                                            placeholder='%'
                                                            required={true}
                                                            displayType='input'
                                                            value={percentageOwnership}
                                                            onChange={(event: any) => set_percentageOwnership(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='legal-entity-name'>
                                                            Legal Entity Name <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='text'>
                                                                Legal name of entity that will be the borrower, e.g Smith Builders
                                                                25, LLC
                                                            </span>
                                                        </span>
                                                        <input
                                                            id='legal-entity-name'
                                                            type='text'
                                                            required={true}
                                                            value={entityName}
                                                            onChange={(event) => set_entityName(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='tax-id'>
                                                            EIN/Tax Identification <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='text'>
                                                                Your Employer Identification Number or Tax Identification Number,
                                                                e.g XX-XXXXXX
                                                            </span>
                                                        </span>
                                                        <input
                                                            id='tax-id'
                                                            type='text'
                                                            value={tin}
                                                            required={true}
                                                            onChange={(event) => set_tin(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='entityType'>
                                                            Select year that your entity was incorporated
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <YearInput
                                                            id='yearIncorporated'
                                                            value={
                                                                yearIncorporated
                                                                    ? new Date(yearIncorporated).getUTCFullYear()
                                                                    : null
                                                            }
                                                            required={true}
                                                            onChange={(event: any) => onYearSelection(event.target.value)}
                                                            maxWidth='190px'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='selectState'>
                                                            Please select the state in which your business was incorporated
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <select
                                                            id='selectState'
                                                            required={true}
                                                            value={stateIncorporated}
                                                            onChange={(e) => set_stateIncorporated(e.target.value)}
                                                        >
                                                            {stateSelectorValues.map((x) => (
                                                                <option
                                                                    key={x.value}
                                                                    value={x.display}
                                                                >
                                                                    {x.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                {/* <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='unitCount'>Organizational Documents</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                Upload the organizational documents for this Entity
                                                            </span>
                                                        </span>
                                                        <div style={{ border: '1px solid lightgray' }}>
                                                            <FileUploader
                                                                id='organizationalFiles'
                                                                selectButtonText='Select Files'
                                                                uploadMode='useForm'
                                                                maxFileSize={1024 * 1024 * 35}
                                                                invalidFileExtensionMessage='Invalid File Type. File will be ignored'
                                                                invalidMaxFileSizeMessage='File too large. File will be ignored'
                                                                multiple={true}
                                                                allowedFileExtensions={['.pdf', '.png', '.jpg']}
                                                                allowCanceling={true}
                                                                labelText='or Drag & Drop the file here'
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className='modal-content-actions'>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={cancelBorrowerEntityOwnerEntity}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={saveOwnerEntity}
                                                    disabled={!canContinue || !saveEnabled}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div>
    );
};
